export const DEFAULT_ALLOWED_CONSUMER_ORIGIN = '*';
